import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { ItemTypeEnum, ObjectTypeFormProps, ObjectTypeFormHandle } from './types';

import TraversingDrapeForm from './TraversingDrapeForm';
import SidePanelForm from './SidePanelForm';
import RomanShadeForm from './RomanShadeForm';
import RollerShadeForm from './RollerShadeForm';
import RomanValanceForm from './RomanValanceForm';
import PleatedValanceForm from './PleatedValanceForm';
import TailoredValanceForm from './TailoredValanceForm';
import ShirredValanceForm from './ShirredValanceForm';
import BalloonShadeForm from './BalloonShadeForm';
import AustrianShadeForm from './AustrianShadeForm';
import PillowForm from './PillowForm';
import ShamForm from './ShamForm';
import BolsterPillowForm from './BolsterPillowForm';
import CushionForm from './CushionForm';
import DustskirtForm from './DustskirtForm';
import BoxSpringCoverForm from './BoxSpringCoverForm';
import DuvetForm from './DuvetForm';
import CoverletForm from './CoverletForm';
import TableclothRoundForm from './TableclothRoundForm';
import TableclothRectangleForm from './TableclothRectangleForm';
import FurnitureForm from './FurnitureForm';
import BenchForm from './BenchForm';
import CorniceForm from './CorniceForm';
import BedForm from './BedForm';
import ReupholsterBenchForm from './ReupholsterBenchForm';
import ReupholsterOttomanForm from './ReupholsterOttomanForm';
import ReupholsterPopSeatForm from './ReupholsterPopSeatForm';
import ReupholsterDiningChairForm from './ReupholsterDiningChairForm';
import PinBoardForm from './PinBoardForm';

export * from './types';

export const ITEM_TYPE_FORM_COMPONENTS: Record<ItemTypeEnum, ForwardRefExoticComponent<ObjectTypeFormProps & RefAttributes<ObjectTypeFormHandle>>> = {
  traversing_drape: TraversingDrapeForm,
  side_panel: SidePanelForm,
  roman_shade: RomanShadeForm,
  roller_shade: RollerShadeForm,
  roman_valance: RomanValanceForm,
  pleated_valance: PleatedValanceForm,
  tailored_valance: TailoredValanceForm,
  shirred_valance: ShirredValanceForm,
  balloon_shade: BalloonShadeForm,
  austrian_shade: AustrianShadeForm,
  pillow: PillowForm,
  sham: ShamForm,
  bolster_pillow: BolsterPillowForm,
  cushion: CushionForm,
  dustskirt: DustskirtForm,
  box_spring_cover: BoxSpringCoverForm,
  duvet: DuvetForm,
  coverlet: CoverletForm,
  tablecloth_round: TableclothRoundForm,
  tablecloth_rectangle: TableclothRectangleForm,
  furniture: FurnitureForm,
  bench: BenchForm,
  cornice: CorniceForm,
  bed: BedForm,
  reupholster_bench: ReupholsterBenchForm,
  reupholster_ottoman: ReupholsterOttomanForm,
  reupholster_pop_seat: ReupholsterPopSeatForm,
  reupholster_dining_chair: ReupholsterDiningChairForm,
  pin_board: PinBoardForm,
};
